/**
 * @flow
 */

import styled, { css } from 'styled-components'
import { lighten, darken, rgba } from 'polished'
import { colors } from '../theme'

interface PrimaryButtonProps {
  hideOnDesktop?: boolean;
  inverted?: boolean;
}

const PrimaryButton =
  styled.button <
  PrimaryButtonProps >
  `
  width: 125px;
  height: 45px;
  margin: 0;
  padding: 0;

  ${({ inverted }) => css`
    background: linear-gradient(
      40deg,
      ${darken(0.3, inverted ? colors.secondary : colors.primary)},
      ${inverted ? colors.secondary : colors.primary}
    );

    border: 1px solid
      ${darken(0.1, inverted ? colors.secondary : colors.primary)};
    box-shadow: 0 0 0 0
      ${rgba(inverted ? colors.secondary : colors.primary, 0.7)};

    &:hover {
      background: linear-gradient(
        40deg,
        ${darken(0.4, inverted ? colors.secondary : colors.primary)},
        ${inverted ? colors.secondary : colors.primary}
      );
      animation: none;
      cursor: pointer;
    }
  `}
  color: white;
  border-radius: 100px;
 
  transition: all 0.4s ease;
  text-transform: uppercase;
  letter-spacing: 2px;

  ${(props) =>
    props.hideOnDesktop &&
    css`
      height: 35px;

      @media screen and (min-width: 850px) {
        display: none;
      }
    `} 
    
   

  &:active {
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06), 0 2px 40px rgba(0, 0, 0, 0.16);
    border-color: ${lighten(0.15, colors.primary)};
    color: ${lighten(0.15, colors.primary)};
  }

  &:focus {
    outline: none;
  }
`

export default PrimaryButton
